import { createSlice } from '@reduxjs/toolkit'
const localSorageLang = localStorage.getItem('language');
const initialState = {
    // language : localSorageLang ? localSorageLang : 'FR',
    lang : localSorageLang ? localSorageLang : 'FR',
    format: {
        full: 'DD/MM/YYYY',
        weekYear: 'WW-YYYY',
        dayMonth: 'DD/MM',
        monthYear: 'MM/YYYY'
    }
}

export const langSlice = createSlice({
    name: 'lang',
    initialState,
    reducers: {
        editLang: (state, action) => {
            state.lang = action.payload
            if (action.payload === 'FR') {
                state.format = {
                    home: "accueil",
                    full: 'DD/MM/YYYY',
                    weekYear: 'WW-YYYY',
                    dayMonth: 'DD/MM',
                    monthYear: 'MM/YYYY'
                }
            }
            if (action.payload === 'EN') {
                state.format = {
                    home: "home",
                    full: 'MM/DD/YYYY',
                    weekYear: 'WW-YYYY',
                    dayMonth: 'MM/DD',
                    monthYear: 'MM/YYYY'
                }
            }
        }
    }
})

export const {
	editLang,
} = langSlice.actions
export default langSlice.reducer